import { ChevronDown } from 'lucide-react'

import { useOrganisations } from '@/hooks/useOrganisations'
import { useAuthStore } from '@/stores/auth'
import { useOrgStore } from '@/stores/org'

export function OrgSelector() {
  const user = useAuthStore((s) => s.user)
  const selectedOrgId = useOrgStore((s) => s.selectedOrgId)
  const setSelectedOrgId = useOrgStore((s) => s.setSelectedOrgId)
  const { data: orgs, isLoading } = useOrganisations()

  // Niet-superadmin ziet geen selector (heeft toch maar 1 org)
  if (user?.rol !== 'superadmin') return null
  if (isLoading) return null
  if (!orgs || orgs.length === 0) {
    return (
      <div className="px-3 mb-3 text-xs text-kh-gray-300">
        Nog geen klanten aangemaakt.
      </div>
    )
  }

  return (
    <div className="px-3 mb-3">
      <label className="block text-[10px] uppercase tracking-wider text-kh-gray-300 mb-1">
        Klant
      </label>
      <div className="relative">
        <select
          value={selectedOrgId ?? ''}
          onChange={(e) => setSelectedOrgId(Number(e.target.value))}
          className="w-full appearance-none bg-kh-blueDark text-white text-sm
                     rounded-md pl-3 pr-8 py-2 border border-kh-blueLight
                     focus:outline-none focus:ring-2 focus:ring-kh-gold
                     cursor-pointer"
        >
          {orgs.map((o) => (
            <option key={o.id} value={o.id}>{o.naam}</option>
          ))}
        </select>
        <ChevronDown
          size={16}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-kh-gold pointer-events-none"
        />
      </div>
    </div>
  )
}
